const API_URL = process.env.REACT_APP_API_URL;
const MINIMUM_BREAK_TIME = process.env.REACT_APP_MINIMUM_BREAK_TIME_IN_SECONDS;
const JIRA_API_URL = process.env.REACT_APP_JIRA_API_URL;

module.exports = {
  API_URL,
  MINIMUM_BREAK_TIME: MINIMUM_BREAK_TIME ? MINIMUM_BREAK_TIME : 300,
  JIRA_API_URL,
  MINIMUM_JIRA_TIME: (process.env.REACT_APP_MINIMUM_JIRA_TIME_IN_HOURS ?? 9) * 3600,
  MINIMUM_OFFICE_TIME: (process.env.REACT_APP_MINIMUM_OFFICE_TIME_IN_HOURS ?? 9) * 3600,
};
